import { ApiResponseType } from '@/api/type/commonTypes';
import { api } from '../axiosInstance';
import {
  GetPartnerServiceOptionsResponse,
  PutServiceOptionsReqeust,
} from '../type/types';

// 파트너 서비스 등록
export const putServiceOptions = async (data: PutServiceOptionsReqeust) => {
  const res = await api.put<
    ApiResponseType<GetPartnerServiceOptionsResponse[]>
  >(`/api/web/partners/partner-services/${data.partnerServiceId}/options`, {
    parentServiceOptionIds: data.parentServiceOptionIds,
    customOptionNames: data.customOptionNames,
    designOnly: data.designOnly,
  });
  return res.data;
};
